import axios from 'axios'
import { ManualShipmentRuleResponse } from '@/api/services/common.dto'
import {
    CommonPortionFamilyTreeRequest, CommonSampleFamilyTreeRequest,
    CommonSubportionFamilyTreeRequest
} from '@/api/resources/common/shared/models/common.models'

class CompatibleShipmentRuleFinderService {
    async findSamplesCompatibleManualShipmentRules(samples: CommonSampleFamilyTreeRequest[], laboratoryId: number): Promise<ManualShipmentRuleResponse[]> {
        const response = await axios.put<ManualShipmentRuleResponse[]>(`/shipments/laboratory/${laboratoryId}/manualShipmentRules/findCompatibleForSamples`, samples)
        return response.data
    }
    async findPortionsCompatibleManualShipmentRules(portions: CommonPortionFamilyTreeRequest[], laboratoryId: number): Promise<ManualShipmentRuleResponse[]> {
        const response = await axios.put<ManualShipmentRuleResponse[]>(`/shipments/laboratory/${laboratoryId}/manualShipmentRules/findCompatibleForPortions`, portions)
        return response.data
    }
    async findSubportionsCompatibleManualShipmentRules(subportions: CommonSubportionFamilyTreeRequest[], laboratoryId: number): Promise<ManualShipmentRuleResponse[]> {
        const response = await axios.put<ManualShipmentRuleResponse[]>(`/shipments/laboratory/${laboratoryId}/manualShipmentRules/findCompatibleForSubportions`, subportions)
        return response.data
    }
}

export const compatibleShipmentRuleFinderService = new CompatibleShipmentRuleFinderService()
